// extracted by mini-css-extract-plugin
export default {"svgIcon":"deviceManageStyle_svgIcon__HQ4UC","blinkColor":"deviceManageStyle_blinkColor__minDH","blinkColors":"deviceManageStyle_blinkColors__7BXKW"};